import {PIXI} from '@colonist/pixi'
import {TranslationObject} from '@colonist/i18n'
import {uiGameManager} from '../EntryShared'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

export class AnimatedSpriteView extends PIXI.AnimatedSprite {
    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, textures: PIXI.Texture[], padding: number = 0) {
        super(textures)

        this.x = x + padding
        this.y = y + padding
        this.width = w - padding * 2
        this.height = h - padding * 2
        container.addChild(this)
    }

    centerXInParent() {
        if(this.parent == undefined) return
        this.x = this.parent.width / 2 - this.width / 2
    }

    centerYInParent() {
        if(this.parent == undefined) return
        this.y = this.parent.height / 2 - this.height / 2
    }

    setTip(title: TranslationObject, bodyParagraphs: TranslationObject[]) {
        const toolTipText: ToolTipText = () => ({title: title, body: bodyParagraphs})
        uiGameManager.toolTipController.createTip(toolTipText, this)
    }
}
